import React from 'react';
import { Card, Grid, Space, theme } from 'antd';

const { useBreakpoint } = Grid;

interface SummarySectionCardProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/**
 * Titled section card used for the content blocks of summary pages.
 */
export function SummarySectionCard({ icon, title, extra, style, children }: SummarySectionCardProps) {
  const { token } = theme.useToken();
  // Phones get tighter padding so content keeps most of the narrow card width.
  const bodyPadding = useBreakpoint().sm === false ? token.padding : token.paddingLG;

  return (
    <Card
      title={(
        <Space style={{ minWidth: 0, maxWidth: '100%' }}>
          <span style={{ color: token.colorPrimary, fontSize: token.fontSizeLG + 2, display: 'inline-flex' }}>{icon}</span>
          <span style={{ fontSize: token.fontSizeLG, fontWeight: 600, whiteSpace: 'normal' }}>{title}</span>
        </Space>
      )}
      extra={extra}
      style={style}
      styles={{
        body: { padding: bodyPadding },
        header: { borderBottom: `1px solid ${token.colorBorderSecondary}`, paddingInline: bodyPadding }
      }}
    >
      {children}
    </Card>
  );
}

export default SummarySectionCard;
